import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import SessionContainer from './SessionContainer';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { PricingProvider } from './contexts/PricingContext';
import { MarketplaceProvider } from './contexts/MarketplaceContext';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { initializeGlobalSetup } from './globalSetup';

// Initialize global setup once at app startup
initializeGlobalSetup();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <NotificationProvider>
        <PricingProvider>
          <AuthProvider>
            <BrandingProvider>
              <DataProvider>
                <MarketplaceProvider>
                  <SessionContainer />
                </MarketplaceProvider>
              </DataProvider>
            </BrandingProvider>
          </AuthProvider>
        </PricingProvider>
      </NotificationProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
